<svg class="custom-icon" [ngClass]="[icon, size]" viewBox="0 0 16 16">
  <use [attr.xlink:href]="iconRef"></use>
</svg>
